module.exports = __webpack_public_path__ + "taiga-logo.png";


//////////////////
// WEBPACK FOOTER
// ./images/integrations/taiga-logo.png
// module id = 1268
// module chunks = 74